<template>
  <div class="c-action-buttons">
    <div>
      <button
        v-if="showPrevBtn()"
        class="c-action-buttons__button"
        :disabled="prevDisabled"
        :type="prevType"
        @click.prevent="handlePrevButtonClick()"
        :tabindex="prevDisabled ? -1 : 0"
      >
        {{ prevLabel }}
      </button>
    </div>

    <div>
      <button
        v-if="showNextBtn()"
        class="c-action-buttons__button"
        :class="{ 'is-loading': nextLoading }"
        :disabled="nextDisabled"
        :type="nextType"
        @click.prevent="handleNextButtonClick()"
        :tabindex="nextDisabled ? -1 : 0"
      >
        
        {{ nextLabel }}
        <div v-if="nextLoading" class="c-spinner">
          <div></div>
          <div></div>
          <div></div>
        </div>
      </button>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      id: {
        type: String,
      },
      showPrev: {
        type: Boolean,
        default: true,
      },
      showNext: {
        type: Boolean,
        default: true,
      },
      prevLabel: {
        type: String,
        default: "Back",
      },
      nextLabel: {
        type: String,
        default: "Next",
      },
      prevDisabled: {
        type: Boolean,
        default: false,
      },
      nextDisabled: {
        type: Boolean,
        default: false,
      },
      nextLoading: {
        type: Boolean,
      },
      prevType: {
        type: "button" | "submit",
        default: "button",
      },
      nextType: {
        type: "button" | "submit",
        default: "button",
      },
    },
    methods: {
      showNextBtn() {
        return this.nextLabel.length > 0 ? this.showNext : false;
      },
      showPrevBtn() {
        return this.prevLabel.length > 0 ? this.showPrev : false;
      },
      handleNextButtonClick() {
        this.$emit("onNext", this.id);
      },
      handlePrevButtonClick() {
        this.$emit("onPrev", this.id);
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/components/consumer/forms/action-buttons/ActionButtons.vue